/** ======= Get all diamond products-Cart =========== **/
function getDiamondProductFromCart() {
  var vowProductInfo = {}
  fetchCartData.items.map(function(data, i) {
    if(data.product_type == "Diamond"){
      vowProductInfo['diamond_productId'] = data.product_id.toString()
      vowProductInfo['diamond_variantId'] = data.variant_id.toString() 
      vowProductInfo['diamond_retailPrice'] = '$' + (data.price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
      vowProductInfo['diamondTitle'] = data.title
    }
  })  
  return vowProductInfo;
}

/** ========= Checking Diamond Price ========= **/
function checkDiamondPriceMatchedorNot(redirectUserCheckout) {
  try {
    var diamondProductInfo = getDiamondProductFromCart()
    if (diamondProductInfo && diamondProductInfo.diamond_productId) {
      return fetch(`${portalApiUrl}/verify_diamond_price`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(diamondProductInfo)
      })
      .then(response => response.json())
      .then(function (res) {
        if (res && res.action && res.action == "remove") {
          jQuery("#bespokeModalCart").find(".cm-modal-title").text("The price of your diamond has changed.")
          jQuery("#bespokeModalCart").find(".cm-modal-subtitle").text("Please click continue to see the updated price.")
          jQuery("#bespokeModalCart").find(".cusCartButton").text("Continue")
          jQuery("#bespokeModalCart").addClass("open")
        } else {
          if (redirectUserCheckout === true){
            window.location.href = '/checkout'
          }
        }
      })
    }
  } catch (error) {
    console.log('An error occurred:', error);
    if (redirectUserCheckout === true){
      window.location.href = '/checkout'
    }
  }
}

/** ========= DIAMOND ABSENT CHECK: Code for showing Error message popup if diamond ring is not present ========= **/
function checkBespokeDiamondConditions() {
  var allCartProducts = fetchCartData.items
  var isDiamondPresentInOrder = true
  var isVowSettingPresentInOrder = true
  
  // #1: If vow product is present in order or not
  var vowProductPresent = true
  for (var i = 0; i < allCartProducts.length; i++) {
    if (allCartProducts[i].product_type === 'Vow Engagement Rings'){
      vowProductPresent = false
      break;
    }
  }
  // #2: If vow product is present then checking diamond is present or not
  if (!vowProductPresent) {
    var diamondPresent = false
    for (var i = 0; i < allCartProducts.length; i++) {
      if (allCartProducts[i].product_type === 'Diamond') {
        diamondPresent = true
        break;
      }
    }
    if (!diamondPresent) {
      isDiamondPresentInOrder = false; /* Diamond and vow rings both are present */
    }
  }
  // #3: If vow product is present then checking 
  var diamondProductPresent = true
  for (var i = 0; i < allCartProducts.length; i++) {
    if (allCartProducts[i].product_type === 'Diamond'){
      diamondProductPresent = false
      break;
    }
  }    
  // #4: If diamond product is present then checking setting is present or not
  if (!diamondProductPresent) {
    var settingPresent = false
    for (var i = 0; i < allCartProducts.length; i++) {
      if (allCartProducts[i].product_type === 'Vow Engagement Rings' || allCartProducts[i].product_type === 'Engagement Rings' || allCartProducts[i].product_type === 'Engagement Ring'){
        settingPresent = true
        break;
      }
    }
    if (settingPresent) {
      isVowSettingPresentInOrder = true;  /* Diamond and vow rings both are present */
    } else {
      isVowSettingPresentInOrder = false; /* Diamond is not present but vow rings is present */
    }
  }

  /* Popup triggers when Diamond doesn't contains Diamond or Sold Out */
  if (!isDiamondPresentInOrder) {
    $('#continue_button').attr('disabled', true)
    jQuery("#bespokeModalCart").find(".cm-modal-subtitle").text("This diamond is not available, please select a different diamond.")
    jQuery("#bespokeModalCart").addClass("open")
  }
  /* Popup triggers when Diamond doesn't contains Settings */
  if (!isVowSettingPresentInOrder) {
    $('#continue_button').attr('disabled', true)
    jQuery("#bespokeModalCart").find(".cm-modal-subtitle").text("This diamond has no setting, please select a setting")
    jQuery("#bespokeModalCart").addClass("open")
  }
}

/** ======== Removing the settings from cart and redirecting to product detail page ======== **/
function redirectToBespokePdp(e) {
  jQuery(e).attr("disabled", true);
  var vowProductInfo = {};
  var itemsToRemove = [];  /* Getting the items which we have to remove */
  
  fetchCartData.items.map(function(data, i) {
    if(data.product_type == "Diamond" || data.product_type == "Vow Engagement Rings"){
      itemsToRemove.push(data.variant_id);
    }
  })  
  if (itemsToRemove.length > 0) {
    var newCartData = {};  /* Data to update cart */
    fetchCartData.items.map(function (item, i) {
      if (item.product_type == "Vow Engagement Rings") {
        vowProductInfo = item;
      }
      if (itemsToRemove.indexOf(item.id) !== -1) {
        newCartData[item.id] = 0;
      }
    });

    localStorage.removeItem("seletedDiamond");
    
    if (Object.keys(newCartData).length > 0) {
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { updates: newCartData },
        dataType: 'json',
        success: function (data) {
          redirectProduct(vowProductInfo)
        },
        error: function (XMLHttpRequest, textStatus) {
          redirectProduct(vowProductInfo)
        }
      });
    } else {
      redirectProduct(vowProductInfo)
    }
  } else {
    redirectProduct(vowProductInfo)
  }
}

/* Redirect product to PDP or Homepage */
function redirectProduct(vowProductInfo) {
  if (vowProductInfo && vowProductInfo.handle) {
    window.location.href = `/products/${vowProductInfo.handle}`;
  } else {
    window.location.href = `/collections/build-your-own-ring`;
  }
}

/* Checkout Button Click Action */
$("#bespokeCheckoutButton").on("click", function(event) {
  const redirectUserCheckout = true;
  checkDiamondPriceMatchedorNot(redirectUserCheckout);
});